import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Modal from "../../../../../../components/Modal";
import { Formik } from "formik";
import { Center } from "../../../../../../components/StyledComponents";
import { schema } from "../../../../../../constants/form/cdoc/addUser";
import Grid from "../../../../../../components/Grid";

import Submit from "../../../../../../components/Form/Submit";

import { hideModal } from "../../../../../../store/actions/modal";

import { StateDto } from "../../../../../../types/states.dto";
import { resetUpdateCDOCs } from "../../../../../../store/actions/cdoc";

import { updateRoadmap } from "../../../../../../store/actions/roadmap";

const Component = ({
  updateStates,
  roadmap,
}: {
  updateStates: StateDto;
  roadmap: {
    _id: string;
    published: boolean;
    name: string;
    description: string;
    __v: number | string;
  };
}) => {
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [formActions, setFormActions] = useState<{ resetForm: () => void }>();
  const dispatch = useDispatch();

  const onSubmit = ({ values, actions }) => {
    dispatch(
      updateRoadmap({
        _id: roadmap._id,
        body: {
          published: !roadmap.published,
          available: !roadmap.published,
          __v: roadmap.__v,
        },
      })
    );

    setFormActions(actions);
  };

  useEffect(() => {
    if (updateStates.success) {
      dispatch(hideModal());
      formActions?.resetForm();
    }

    if (updateStates.error) {
      setTimeout(() => {
        dispatch(resetUpdateCDOCs());
      }, 1000);
    }
  }, [updateStates]);

  return (
    <Modal
      name="private-roadmap"
      title={`¿Seguro quieres cambiar el status del roadmap a ${
        !!roadmap.published ? "Privado" : "Publico"
      }?`}
      description={
        !!roadmap.published
          ? `El Roadmap se esconderá en todos los lugares en donde esta publicado. Ningún usuario podrá acceder a el.`
          : `El Roadmap se mostrara en todos los lugares en donde esta publicado. Los usuarios podran acceder.`
      }
    >
      <Formik
        initialValues={{}}
        onSubmit={(values, actions) => {
          if (onSubmit) onSubmit({ values, actions });
        }}
        validateOnChange={formSubmmited}
        validateOnBlur={false}
        validationSchema={schema}
        enableReinitialize
      >
        {({
          touched,
          errors,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          setFieldValue,
          isSubmitting,
        }) => {
          return (
            <form
              className="theme-form"
              onSubmit={(event) => {
                setFormSubmmited(true);
                handleSubmit(event);
              }}
              id="invite-academy-modal-form"
            >
              <Grid.Row>
                <Grid.Col>
                  <Center gap={"10px"}>
                    <Submit
                      isSubmmiting={isSubmitting}
                      form="invite-academy-modal-form"
                      color="Primary"
                      style={{ width: "170px" }}
                      options={{
                        type: "filled",
                        skin: "primary",
                        size: "lg",
                        marginBottom: "0px",
                      }}
                    >
                      Confirmar
                    </Submit>
                  </Center>
                </Grid.Col>
              </Grid.Row>
            </form>
          );
        }}
      </Formik>
    </Modal>
  );
};

const states = ({ cdocStore }) => {
  const { states: updateStates } = cdocStore.update;
  return { updateStates };
};

export default connect(states)(Component);
